<p-toast position="top-right"></p-toast>
<div class="supplier-Listing-Responsive p-g">
   <div class="p-g-12 p-table-tecfolk-fix">
      <div class="card card-w-title">
         <div class="p-g">
            <div class="p-g-6">
               <h1 style="margin-top: 0px;">{{setLabel("suppliersLabel")}}</h1>
            </div>
            <div class="p-g-6">
            </div>
         </div>
         <div>
            <p-table #dt [value]="suppliers" [paginator]="true" [rows]="6" [responsive]="true" [loading]="loading"
               [first]="first" (onPage)="onPageChange($event)">

               <ng-template pTemplate="caption" style="text-align: left">
                  <div class="reportMainFilter">
                     <div class="reportMainFields">
                        <div class="filterFields">
                           <span class="fieldTitle">{{setLabel("searchBySupplierNameLabel")}}</span>
                           <input id="searchSupplier" #searchSupplier (keyup)="searchLocal(supplier.name, 'name')"
                              [(ngModel)]="supplier.name" autocomplete="off" pinputtext=""
                              [placeholder]='setLabel("searcherePlaceholderLabel")' type="text" name="name"
                              class="p-inputtext p-corner-all p-state-default p-widget">
                        </div>
                        <div class="reportMainBtn">
                           <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" class="iconClear" [disabled]="loading"
                              (click)="clear()"> <i class="pi pi-times"></i></span>
                        </div>
                     </div>

                     <div class="reportMainBtn">
                        <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" class="iconClear hideOnLaptop"
                           [disabled]="loading" (click)="clear()"> <i class="pi pi-times"></i></span>

                        <!-- <button pButton type="button" class="clear-Search-Btn p-widget p-state-default p-corner-all"
                           (click)="clear()" label="Clear Search">
                        </button> -->

                        <span [pTooltip]='setLabel("addNewTooltipLabel")' tooltipPosition="top" routerLink="/supplier" class="iconClear "
                           [disabled]="loading"> <i class="pi pi-user-plus"></i></span>

                        <!-- <button routerLink="/supplier" pButton type="button"
                           class="add-New-Btn p-button p-widget p-state-default p-corner-all suppliersButtons"
                           label="Add New">
                        </button> -->
                     </div>
                  </div>
               </ng-template>

               <ng-template pTemplate="header">
                  <tr>
                     <th style="max-width: 90px;">{{setLabel("nameLabel")}}</th>
                     <th style="max-width: 90px;">{{setLabel("imageLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("mobile#Label")}}</th>
                     <th style="max-width: 130px; text-align: center;">{{setLabel("actionLabel")}}</th>
                  </tr>
               </ng-template>

               <ng-template pTemplate="body" let-rowData>
                  <tr>
                     <td>
                        <div class="mobile-Lable">{{setLabel("nameLabel")}}</div>
                        {{rowData.name}}
                     </td>
                     <td>
                        <div class="mobile-Lable-Image">{{setLabel("imageLabel")}}</div>
                        <a (click)="openPhoto(rowData.profile)">
                           <img [alt]="" src="{{rowData.profile}}" width="60" style="vertical-align: middle" />
                        </a>
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("mobile#Label")}}</div>
                        {{rowData.phone}}
                     </td>

                     <td class="action-Btn">

                        <div class="mobile-Lable">{{setLabel("actionLabel")}}</div>
                        <button pButton type="button" [pTooltip]='setLabel("deactivateSupplierTooltipLabel")'
                           tooltipPosition="top" style="margin-right: 5px;" class="p-button-danger p-button"
                           icon="fa fa-times" (click)="deleteSupplier(rowData)">
                        </button>

                        <button pButton type="button" [pTooltip]='setLabel("editSupplierDetailsTooltipLabel")'
                           tooltipPosition="top" icon="fa fa-pencil-square-o" (click)="viewSupplier(rowData)"
                           style="margin-right: 5px;">
                        </button>
                     </td>
                  </tr>
               </ng-template>

               <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                     <td>
                        {{setLabel("noSupplierFoundLabel")}}
                     </td>
                  </tr>
               </ng-template>

            </p-table>
         </div>
      </div>

      <div class="image-Main" *ngIf="imgPreview" (click)="closePhotoPreview()">
         <svg (click)="closePhotoPreview()" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times"
            class="svg-inline--fa fa-times fa-w-11" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
            <path fill="currentColor"
               d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
            </path>
         </svg>
         <img src="{{imgPreviewImg}}" style="width: 25vw; height: auto;background: #fff;" />
      </div>
   </div>
</div>